import login from './login/sagas'

export default [login]
